import React from "react";
import ManageUsers from "../../Admin/manage-users/ManageUsers";

const ManageUsersScreen = () => {
    return <ManageUsers />;
};

export default ManageUsersScreen;
